/**
 * 统计 schema.properties 中直接子项的 x-component 为 CnCard 的数量
 * @param {Object} properties - 要分析的对象
 * @returns {number} - CnCard 组件的数量
 */
export function countCnCards(properties) {
    let count = 0;
    if (properties && typeof properties === 'object') {
        for (const key in properties) {
            if (Object.prototype.hasOwnProperty.call(properties, key)) {
                const property = properties[key];
                // 仅判断当前层级的 x-component 是否是 CnCard
                if (property['x-component'] === 'CnCard') {
                    count += 1;
                }
            }
        }
    }
    return count;
}
